import { schema } from 'normalizr';

export const variableSchema = new schema.Entity('variables');

export const profitItemDefSchema = new schema.Entity('profitItemDefs', {
  formula: {
    variables: [variableSchema],
  },
});
